import * as React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";

export default function ValidationTextFields(props: TextFieldProps) {
  return <TextField fullWidth {...props} />;
}
